/*
 * Header Component
 * 
*/


import React from 'react';
import {connect} from 'react-redux';
import { Link } from 'react-router-dom';
import {Nav, Navbar, Image, Fade, Row, Col} from 'react-bootstrap';

//APPs
import Utils from '../../utils/utils';
import appRouter from '../../utils/appRouter';
import menuAPI from '../../api/menu-api';
import UserApi from '../../api/user-api';

//COMPONENTS
import MainMenu from './mainMenu.component.jsx';


class Header extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
		};

		this.setNavExpanded = this.setNavExpanded.bind(this);
		this.closeNav = this.closeNav.bind(this);
	}

	componentDidMount(){		
	}

	setNavExpanded(expanded) {
		menuAPI.toggleMenu(true);
  }

  closeNav() {
		menuAPI.toggleMenu(false);
  }

	isPath(path) {
		let regex = new RegExp('/' + path);
		return regex.test(this.props.location.pathname);
	}

	render() {

    let self = this;
    const pathHome = appRouter.getLink('home');
    const pathGame = appRouter.getLink('game');
		let hasPlan = UserApi.hasPlanActive(this.props.user);

    const bannerLG = 
        <div className="navbar-banner bg-banner shadow hidden-sm hidden-xs">
          <div className="container-banner">
            <Image src={Utils.getImgPath() + "banner-lg.png"} width="100%" alt="" className="banner-lg"/>
          </div>
        </div>;

    const bannerMD = 
      <div className="navbar-banner bg-banner shadow hidden-md hidden-lg">
        <div className="container-banner">
          <Image src={Utils.getImgPath() + "banner-mobile.png"} width="100%" alt="" className="banner-md"/>
        </div>
      </div>;


		return (			
			<div className={'navbar'}>
				<Navbar collapseOnSelect fluid onToggle={this.setNavExpanded} expanded={this.props.menu.state}>
						<Navbar.Header>
							<Navbar.Toggle />

							<Navbar.Brand>
								<Link className="img-responsive" to={pathHome}>
									{!this.isPath('home') &&
										<Image src={Utils.getImgPath() + "logo.svg"} className="hidden-xs hidden-sm"  />
									}
									<Image src={Utils.getImgPath() + "logo-mobile.svg"} className="hidden-md hidden-lg"/>
								</Link>
							</Navbar.Brand>
							
							{hasPlan &&
								<Link to={pathGame}>
									<span className={this.isPath('game') ? 'questions game' : 'questions'}>{this.props.user.game.questionsAvailable}</span>
								</Link>
							}

						</Navbar.Header>
						
						<Navbar.Collapse className="control-position">
							<MainMenu />
						</Navbar.Collapse>
					<Row>
						{this.isPath('home') &&
						<div>
							{bannerLG}
							{bannerMD}
						</div>
						}
					</Row>
				</Navbar>
			</div>
		)
	}
}


const mapStateToProps = function (store) {
	return {
		location: store.locationState.location,
		menu: store.menuState,
		user: store.userState
	};
};

export default connect(mapStateToProps)(Header);


// WEBPACK FOOTER //
// ./src/components/core/header.component.jsx